import React, { useState } from 'react';

// assets
import { Security } from 'icons/untitledui';

// components
import Tooltip from 'sidePanel/components/Tooltip';

// styles
import * as Styled from 'sidePanel/styles/PanelNav.style';
import * as Text from 'theme/components/Text.style';

interface PanelNavProps {
  action?: () => void;
  demoTour?: string;
  expanded?: boolean;
  icon: () => JSX.Element;
  isActive?: boolean;
  inactive?: boolean;
  label?: string;
}

export default function PanelNav({
  action,
  demoTour,
  expanded,
  icon,
  inactive,
  isActive,
  label,
}: PanelNavProps): JSX.Element {
  const [showTooltip, setShowTooltip] = useState(false);

  const handlePointerEnter = (e: React.PointerEvent) => {
    if (e.pointerType !== 'mouse') return;
    if (!expanded && label) {
      setShowTooltip(true);
    }
  };

  const handlePointerLeave = () => {
    setShowTooltip(false);
  };

  if (inactive)
    return (
      <Tooltip content={label || ''} visible={showTooltip}>
        <Styled.InactiveContainer
          expanded={expanded}
          className={demoTour}
          onPointerEnter={handlePointerEnter}
          onPointerLeave={handlePointerLeave}
        >
          <Styled.Label>
            <Security.Lock01 size={15} />
            {expanded && label && <Text.P2Semibold>{label}</Text.P2Semibold>}
          </Styled.Label>
        </Styled.InactiveContainer>
      </Tooltip>
    );

  return (
    <Tooltip content={label || ''} visible={showTooltip}>
      <Styled.Container
        expanded={expanded}
        className={demoTour}
        isActive={isActive}
        onClick={action}
        onPointerEnter={handlePointerEnter}
        onPointerLeave={handlePointerLeave}
      >
        <Styled.Label>
          {icon()}
          {expanded && label && <Text.P2Semibold>{label}</Text.P2Semibold>}
        </Styled.Label>
      </Styled.Container>
    </Tooltip>
  );
}
